import { StoreSchema } from '../../types/store'

export const selectNotifications = (store: StoreSchema) => store.notifications.notifications
export const selectNotificationsHasMore = (store: StoreSchema) => store.notifications.hasMore